import type { FC } from 'react'
import cn from 'classnames'
import { MapMarker } from 'components/icons'
import type { AddressViewProps } from '.'
import s from './address-view.module.css'

const AddressCard: FC<AddressViewProps> = ({ className, address }) => {
  const {
    zipCode,
    street,
    number,
    neighborhood,
    complement,
    type,
    recipient,
    city: { name, district },
  } = address

  return (
    <div className={cn(s.root, className)}>
      <span className={s.tag}>{type}</span>
      <MapMarker className={s.icon} />
      <div className={s.content}>
        <div className={s.lineOne}>
          <strong>{recipient}</strong>
          <br />
          {street}
          {number && `, n.: ${number}`} - {neighborhood}
        </div>
        <div className={s.lineTwo}>
          {name} - {district}, {zipCode}
        </div>
        <div className={s.lineThree}>{complement}</div>
      </div>
    </div>
  )
}

export default AddressCard
